import { ThemeColors } from '../theme-colors';
import { ColorPalette } from '../../base/colorPalette';

export const CustomSlider = {
	trackBackground: ColorPalette.blueGrey100,
	trackActiveBackground: ThemeColors.primary,
	trackActiveDisabledBackground: ColorPalette.blue100,
	trackHeight: 'var(--epods-slider-trackHeight)',
	thumbValueTop: 'var(--epods-slider-thumbValueTop)',
	trackPaddingBottom: 'var(--epods-slider-trackPaddingBottom)',
	thumbCircleWidh: 'var(--epods-slider-thumbCircleWidh)',
	thumbCircleHeight: 'var(--epods-slider-thumbCircleHeight)',
	thumbBackground: ColorPalette.white,
	thumbBorder: ColorPalette.blueGrey500,
	thumbHeight: 'var(--epods--slider--thumb-height)',
	thumbWidth: 'var(--epods--slider--thumb-width)',
	thumbTickWidth: 'var(--epods--slider--inner-thumb-width)',
	thumbTickHeight: 'var(--epods--slider--inner-thumb-height)',
};
